import api from '@/js/services/api';

export default {

    //get

    fetchClientInfo() {
        return api().get(`/client/get`);
    },

    getListOfArtists(client_id, page) {
        return api().get(`/client/${client_id}/artists/get?page=${page}`);
    },

    getListOfBookedArtists(client_id, page) {
        return api().get(`/client/artist/${client_id}/booked/get?page=${page}`);
    },

    getArtistInnerInfo(artist_id) {
        return api().get(`/client/artist/${artist_id}/get`);
    },

    getArtistTestimonials(artist_id) {
        return api().get(`/client/artist/${artist_id}/testimonials/get`);
    },

    // put

    updateClientInfo(clientId, info) {
        return api().put(`/client/${clientId}/update`, info);
    },

    updateAdditionalInformation(clientId, additional_info) {
        return api().put(`/client/${clientId}/additional/update`, {additional_info});
    },

    sendArtistBookingRequest() {

    }

}
